import React, { useState } from 'react';
import { SlidersHorizontalIcon, BookOpenIcon, LightbulbIcon, UsersIcon } from './lib/icons';
import Dashboard from './components/Dashboard';
import AuctioneerDashboard from './components/AuctioneerDashboard';
import TheoryContent from './components/Theory';
import ReadmeContent from './components/Readme';

export default function App() {
    const [activeTab, setActiveTab] = useState('dashboard');

    return (
        <div className="min-h-screen bg-gray-900 text-gray-200 font-sans p-4 lg:p-8" style={{backgroundImage: 'radial-gradient(circle at top right, rgba(29, 78, 216, 0.15), transparent 40%), radial-gradient(circle at bottom left, rgba(29, 78, 216, 0.15), transparent 40%)', paddingTop: '2rem'}}>
            <div className="max-w-7xl mx-auto">
                <header className="mb-6">
                    <div className="header-container">
                        <div className="title-section">
                            <h1 className="title">Advanced Bidding Assistant</h1>
                            <p className="text-lg text-gray-400 mt-2">For Renewable Project Tenders</p>
                        </div>
                        <img src={process.env.PUBLIC_URL + '/logo.webp'} alt="IKUTU Logo" className="logo" />
                    </div>
                </header>

                <div className="flex justify-center mb-6" style={{marginTop: '50px'}}>
                    <div className="flex space-x-1 bg-gray-800/80 p-1 rounded-lg border border-gray-700">
                        <button onClick={() => setActiveTab('dashboard')} className={`tab-button px-4 py-2 text-sm font-medium rounded-md transition ${activeTab === 'dashboard' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`}>
                            <SlidersHorizontalIcon className="h-5 w-5"/>Bidder Dashboard
                        </button>
                        <button onClick={() => setActiveTab('auctioneer')} className={`tab-button px-4 py-2 text-sm font-medium rounded-md transition ${activeTab === 'auctioneer' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`}>
                            <UsersIcon className="h-5 w-5"/>Auctioneer Dashboard
                        </button>
                        <button onClick={() => setActiveTab('theory')} className={`tab-button px-4 py-2 text-sm font-medium rounded-md transition ${activeTab === 'theory' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`}>
                           <BookOpenIcon className="h-5 w-5"/>Theory
                        </button>
                        <button onClick={() => setActiveTab('readme')} className={`tab-button px-4 py-2 text-sm font-medium rounded-md transition ${activeTab === 'readme' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`}>
                           <LightbulbIcon className="h-5 w-5"/>Readme
                        </button>
                    </div>
                </div>

                {activeTab === 'dashboard' ? <Dashboard /> : activeTab === 'auctioneer' ? <AuctioneerDashboard /> : activeTab === 'theory' ? <TheoryContent /> : <ReadmeContent />}
                
                <footer className="text-center text-gray-500 text-xs py-4 mt-8">
                    <p>&copy; 2025 - IKUTU - Sustainable Energy Solutions</p>
                </footer>
            </div>
            {/* KaTeX for rendering mathematical formulas */}
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css" xintegrity="sha384-n8MVd4RsNIU0KOVEMcAqrfxk5DLIeAlxRGcsCopjFIOlCHbCE5pU8so5ZjdDaMn5" crossOrigin="anonymous"/>
            <script src="https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.js" xintegrity="sha384-XjKyOOlGwcjNTAIQHIpgOno0Hl1YQqzUOEleOLALmuqehneUG+vnGctmUb0ZY0l8" crossOrigin="anonymous"></script>
        </div>
    );
}
